// src/App.js
import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import TournamentPage from './pages/TournamentPage';
import FinalRankingPage from './pages/FinalRankingPage';
import AccountPage from './pages/AccountPage';
import PlayerStatsPage from './pages/PlayerStatsPage';
import JoinPage from './pages/JoinPage';
import BigScreenPage from './pages/BigScreenPage';
import SharedTournamentPage from './pages/SharedTournamentPage';
import TestPanel from './testMode/TestPanel';
import { isTestMode } from './testMode/testMode';
import StatusBanner from './components/StatusBanner';
import ConsentBanner from './components/ConsentBanner';
import DiagnosticsPill from './components/DiagnosticsPill';
import LegalFooter from './components/LegalFooter';
import PrivacyPage from './pages/legal/PrivacyPage';
import TermsPage from './pages/legal/TermsPage';
import HelpPage from './pages/legal/HelpPage';
import DeleteAccountInfoPage from './pages/legal/DeleteAccountInfoPage';

// The test dock is for the organiser; spectators on a share link never see it.
function TestDock() {
    const { pathname } = useLocation();
    return isTestMode() && !pathname.startsWith('/s/') ? <TestPanel /> : null;
}

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Login />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/account" element={<AccountPage />} />
                <Route path="/players" element={<PlayerStatsPage />} />
                <Route path="/tournament/:tournamentId" element={<TournamentPage />} />
                <Route path="/tournament/:tournamentId/final" element={<FinalRankingPage />} />
                <Route path="/join/:token" element={<JoinPage />} />
                <Route path="/privacy" element={<PrivacyPage />} />
                <Route path="/terms" element={<TermsPage />} />
                <Route path="/help" element={<HelpPage />} />
                <Route path="/delete-account" element={<DeleteAccountInfoPage />} />
                <Route path="/s/:token/screen" element={<BigScreenPage />} />
                <Route path="/s/:token" element={<SharedTournamentPage />} />
            </Routes>
            <LegalFooter />
            <StatusBanner />
            <ConsentBanner />
            <DiagnosticsPill />
            <TestDock />
        </BrowserRouter>
    );
}

export default App;
